export default __webpack_public_path__ + "static/1232-d36dea1f0ef9f93e06c53fd96f34bff8.gif";